import { render } from "./EditAggregationModal1.vue?vue&type=template&id=382f8dcf&scoped=true"
import script from "./EditAggregationModal1.vue?vue&type=script&lang=js"
export * from "./EditAggregationModal1.vue?vue&type=script&lang=js"

import "./EditAggregationModal1.vue?vue&type=style&index=0&id=382f8dcf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-382f8dcf"]])

export default __exports__